// import {
//     JL
// } from 'jsnlog';

//let ajaxAppender = JL.createAjaxAppender("Ajax Appender");
//var apiUrl = config.config.apiUrl + "Logging/Log";
// ajaxAppender.setOptions({
//     "bufferSize": 20,
//     "storeInBufferLevel": 1000,
//     "level": 4000,
//     "sendWithBufferLevel": 6000,
//     "url": apiUrl
// });

// let consoleAppender = JL.createConsoleAppender("Console Appender");

// let logger = JL();
// logger.setOptions({
//     //"level": config.config.logLevel,
//     "appenders": [consoleAppender]
// });

// TODO: JSNLog always Json.Stringify which is annoying during development
let logger = {
    info: function(m){
        console.log(m);
    },
    warn: function(m){
        console.log(m);
    },
    error: function(m){
        console.log(m);
    },
    fatal: function(m){
        console.log(m);
    },
    trace: function(m){
        console.log(m);
    },
    debug: function(m){
        console.log(m);
    },
}

export default logger;